
















































const namespace = 'calendar';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter } from 'vuex-class';
import { Prop } from 'vue-property-decorator';
import EventBus from '@/communication/EventBus';
import { IDropdownChangeDetails } from '@/modules/calendar/interfaces/IDropdownChangeDetails';
import { CalendarFilter } from '@/modules/calendar/store/types';

@Component({
    name: 'DropdownFilter',
    components: {},
})
export default class DropdownFilter extends Vue {
    @Prop() public odataName!: string;
    @Prop() public odataProperty!: string;
    @Prop() public navigationProperty!: string;
    // @Prop() public options!: string[];
    @Prop() public options!: { value: string; text: string }[];
    @Prop() public inputplaceholder!: string;
    @Prop() public valuesFromUrl!: string[];
    @Getter('isMobile', { namespace }) private isMobile!: number;
    @Getter('getCalendarFilters', { namespace }) private getCalendarFilters!: { [key: string]: CalendarFilter };
    private values: string[] = [];
    private shouldUpdateBasedOnUrl = true;
    private selected: string[] = [];

    private mounted() {
        this.updateSelectedValues();
        EventBus.$on('filtersChanged', this.updateSelectedValues);
    }

    private updateSelectedValues() {
        const calendarFilters = this.getCalendarFilters;
        if (calendarFilters[this.odataName] !== undefined) {
            let filterValues = calendarFilters[this.odataName].propertyFilters.map(f => f.value.toString());
            if (this.odataName === 'StartDate') {
                filterValues = calendarFilters[this.odataName].propertyFilters.map(f =>
                    f.operator === 'gt' ? 'przyszłe' : 'aktywne',
                );
            }
            this.selected = filterValues;
        }
    }

    private remove(item: string) {
        const index = this.selected.indexOf(item);
        if (index >= 0) this.selected.splice(index, 1);
        this.$emit('dropdownChanged', this.getDropdownChangeDetails());
    }

    public updated() {
        if (this.shouldUpdateBasedOnUrl) {
            this.setValues();
        }
    }

    private updateValueAction() {
        const details = this.getDropdownChangeDetails();
        this.$emit('dropdownChanged', details);
        this.shouldUpdateBasedOnUrl = false;
    }

    private get isLoading() {
        return this.options === null;
    }

    private get shouldCloseOnSelect() {
        return this.isMobile;
    }

    private checkAll(): void {
        this.selected = this.options.map(x => x.value);
        this.$emit('dropdownChanged', this.getDropdownChangeDetails());
    }

    private unCheckAll(): void {
        this.selected = [];
        this.values = [];
        this.$emit('dropdownChanged', this.getDropdownChangeDetails());
    }

    private getDropdownChangeDetails() {
        const dropdownChangeDetails: IDropdownChangeDetails = {
            odataName: this.odataName,
            odataProperty: this.odataProperty,
            values: this.selected,
            navigationProperty: this.navigationProperty,
        };
        return dropdownChangeDetails;
    }

    private setValues() {
        this.values = this.valuesFromUrl;
    }
}
